import { useState, useRef, useEffect } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

const SortDrawer = ({ filters, activeFilter, setActiveFilter ,className}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const drawerRef = useRef();

  // عنوان collapse
  const collapseTitle = activeFilter
    ? filters.find((f) => f.name === activeFilter)?.label
    : "مرتب‌سازی";

  // بستن collapse هنگام کلیک خارج
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        setDrawerOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // حذف گزینه فعال از لیست
  const filteredOptions = filters.filter((f) => f.name !== activeFilter);

  return (
    <div className={`relative flex justify-end text-left ${className}`} >
      {/* دکمه collapse */}
      <button
      ref={drawerRef}
        className="text-[#383838] text-[12px] ms:text-[13px] w-full
        py-2 px-4 border rounded-[12px] flex justify-center gap-2 items-center"
        onClick={() => setDrawerOpen(!drawerOpen)}
      >
        
        {drawerOpen ? <FiChevronUp /> : <FiChevronDown />}
        <span>{collapseTitle}</span>
      </button>

      {/* drawer absolute */}
      {drawerOpen && filteredOptions.length > 0 && (
        <div className="absolute left-0 top-full z-50 w-[180px] bg-white border border-[#d2d2d2bd] rounded-[12px] overflow-hidden flex flex-col mt-1">
          {filteredOptions.map((filter) => (
            <button
              key={filter.name}
              className="text-sm text-start py-2 px-3 hover:bg-[#F6F6F6] text-gray-700"
              onClick={() => {
                setActiveFilter(filter.name);
                setDrawerOpen(false);
              }}
            >
              {filter.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SortDrawer;
